export default "__VITE_ASSET__7266a382__"